/**
 * @file 環境依存の定数
 * @author Ozaki Takao
 */
(function () {
  'use select';

  if (typeof window.Env === 'undefined') {
    window.Env = {};
  }
  var env = {
    // システム名称
    SYSTEM_NAME: 'TOA音声配信サービス(CICD)',

    // 試作環境用CognitoのUserPoolId
    COGNITO_USER_POOL_ID: 'ap-northeast-1_q3bdfTGxv',

    // 試作環境用CognitoのClientId
    COGNITO_CLIENT_ID: '68roohl1pjc9da4fvna0gvmc4v'
  };

  Object.keys(env).forEach(key => {
    window.Env[key] = env[key];
  });
}());
